import { EProvince } from './enums';
export const getMinimumAgeRequirementByStateIso = (iso) => {
    switch (iso) {
        case EProvince.NewBrunswick:
        case EProvince.Newfoundland:
        case EProvince.NovaScotia:
            return 19;
        default:
            return 18;
    }
};
